// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disabled[data-v-01165c2e]{background-color:gray !important;pointer-events:none}", "",{"version":3,"sources":["webpack://./src/component/booking/CancelBookingPopup.vue"],"names":[],"mappings":"AAiIA,2BACE,gCAAA,CACA,mBAAA","sourcesContent":[".disabled{background-color:gray !important;pointer-events:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
